import { Box } from '@mui/material';
import { InstanceExportOptions } from '../../../options/InstanceExportOptions';
import { ReportSummaryDetails } from '../../common/components/ReportHeader';
import { BasePrintController, BasePrintControllerProps, BasePrintControllerState } from '../../common/controllers/BasePrintController';
import { InstanceDetails } from '../components/InstanceDetails';
import { InstancePrintData } from '../models/InstancePrintData';
import { InstancePrintRepository } from '../services/InstancePrintRepository';

type Props = BasePrintControllerProps & {
  options: InstanceExportOptions;
};

type State = BasePrintControllerState & {};

export class InstancePrintController extends BasePrintController<Props, State> {
  private readonly repository = new InstancePrintRepository();
  private instance: InstancePrintData | null = null;

  componentDidMount(): void {
    this.fetchInstance();
  }

  componentWillUnmount(): void {
    this.repository.cancelAllRequests();
  }

  render() {
    if (!this.instance) return <></>;

    return this.renderBase(
      <Box>
        <Box sx={{ mb: 2 }}>
          <ReportSummaryDetails report={this.instance.getReport()} />
        </Box>
        <Box sx={{ mb: 2 }}>
          <InstanceDetails instance={this.instance} />
        </Box>
      </Box>
    );
  }

  private async fetchInstance() {
    try {
      this.instance = await this.repository.getInstance(this.props.options);
      this.onRendered();
    } catch (e: unknown) {
      this.onError(e);
    }
  }
}
